export default __webpack_public_path__ + "static/media/SWT1180.34I-32315_-20567_50.27cbbca8.jpg";